<template>
    <v-container fluid class="main-body">
        <r-header></r-header>
        <RegistraEquipo :carrera="carrera"></RegistraEquipo>
        <Footer></Footer>
    </v-container>
</template>

<script>
    import RegistraEquipo from "../components/shared/RegistraEquipo"
    import RHeader from "../components/shared/HeaderComponent";
    import Footer from "../components/shared/Footer";

    export default {
        name: "Equipos",
        props: ['carrera'],
        components: {Footer, RHeader, RegistraEquipo}

    }
</script>

<style scoped lang="scss">
    @import "./../_static/base";
</style>